import { UserChangePaswordModalForm } from './UserChangePaswordModalForm'

const UserChangePaswordModalFormWrapper = () => {
  return <UserChangePaswordModalForm />
}

export {UserChangePaswordModalFormWrapper}
